import Image from "next/image";

import { Link } from "@/components/ui/link";

import { PartnerTierBadge } from "./tier-badge";
import type { PartnerDirectoryCardData } from "./types";

interface PartnerCardProps {
  partner: PartnerDirectoryCardData;
}

/** Figma 12328:41097 — directory grid card. The whole card is one link. */
export function PartnerCard({ partner }: PartnerCardProps) {
  return (
    <li className="list-none">
      <Link
        href={partner.href}
        data-testid="partner-card"
        className="group bg-grey-50 border-grey-100 rounded-ds-xl hover:border-grey-200 focus-visible:ring-pulse-400 flex h-[251px] w-full flex-col justify-between overflow-clip border p-5 transition-colors duration-[180ms] focus-visible:ring-2 focus-visible:outline-none"
      >
        <PartnerTierBadge tier={partner.tier} label={partner.tierLabel} />
        <div className="relative mx-auto h-[72px] w-full max-w-[160px]">
          <Image
            src={partner.logo.src}
            alt={partner.logo.alt}
            fill
            sizes="160px"
            className="object-contain"
          />
        </div>
        <div className="flex flex-col gap-2">
          <h3 className="text-ds-heading-h4 text-grey-950">{partner.name}</h3>
          <p className="text-ds-body-xs text-grey-600 line-clamp-2 tracking-[-0.02em]">
            {partner.summary}
          </p>
        </div>
      </Link>
    </li>
  );
}
